import { Column, GridContainer, Row, Typography } from '@vp/swan';
import { useInternalViewContext } from '../../hooks/useInternalViewContext';
import { ActiveOrderControl } from './ActiveOrderControl';
import { OrderHistoryApplication } from '../OrderHistoryApplication';

export const InternalViewOrderHistorySession = () => {
  const { internalViewerSuppliedShopperId } = useInternalViewContext();
  return (
    <>
      <GridContainer>
        <Row mt={7} mb={3}>
          <Column span={12}>
            <Typography fontSize="x2large" textAlign="center">
              Welcome to Order History Internal View
            </Typography>
          </Column>
        </Row>
        <Row mb={7}>
          <Column span={6} push={3}>
            <ActiveOrderControl />
          </Column>
        </Row>
      </GridContainer>
      {internalViewerSuppliedShopperId && (
        <>
          <OrderHistoryApplication />
        </>
      )}
    </>
  );
};
